export type ModerationStyleResult = {
    text: string
    background: string
    border: string
    indicator: string
}

/**
 * Returns Tailwind CSS classes for moderation status styling.
 * Used by ClassificationDisplay and ContentMetadataClassification.
 */
export function getModerationStyles(status: string | null | undefined): ModerationStyleResult {
    switch (status?.toUpperCase()) {
        case 'SEVERE':
            return {
                text: 'text-severe-800',
                background: 'bg-severe-50',
                border: 'border-severe-100',
                indicator: 'text-severe'
            }
        case 'SUSPECT':
            return {
                text: 'text-suspect-800',
                background: 'bg-suspect-50',
                border: 'border-suspect-100',
                indicator: 'text-suspect'
            }
        case 'SAFE':
            return {
                text: 'text-safe-800',
                background: 'bg-safe-50',
                border: 'border-safe-100',
                indicator: 'text-safe'
            }
        default:
            return {
                text: 'text-gray-800',
                background: 'bg-gray-50',
                border: 'border-gray-100',
                indicator: 'text-gray-500'
            }
    }
}
